import { useRef, useEffect, forwardRef, useImperativeHandle, useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';

const FJTextWithEllipsisParent = (
    {
        text,
        style,
        className,
        onClick = () => {},
        isRender = true,
        isAddParentTitle = false, //是否添加到父级元素
    },
    ref,
) => {
    const textRef = useRef(null);

    const _update = useCallback(() => {
        const container = textRef.current;
        const titleContainer = isAddParentTitle && container.parentElement ? container.parentElement : container;
        if (container.scrollWidth > container.offsetWidth) {
            titleContainer.setAttribute('title', text);
        } else {
            titleContainer.removeAttribute('title');
        }
    }, [isAddParentTitle, text]);

    useLocalStore();
    useImperativeHandle(ref, () => ({
        update: _update,
    }));
    useEffect(() => {
        if (isRender) {
            _update();
        }
    }, [text, isRender, _update]);

    return (
        <div
            ref={textRef}
            style={{
                overflow: 'hidden', // 隐藏溢出的文本
                textOverflow: 'ellipsis', // 显示省略号
                whiteSpace: 'nowrap', // 防止文本换行
                ...style,
            }}
            className={className}
            onClick={onClick}
        >
            {text}
        </div>
    );
};

export default forwardRef(FJTextWithEllipsisParent);
